import request from "./http.js"


//获取背景图列表
export function getBackground() {
    return request.post('/api/index/getBackground')
}

//获取地板列表信息
export function getFloorList() {
    return request.post('/api/index/getFloorList',{diy_sort:1})
}


//获取管道分类及子分类
export function getConduitCate() {
    return request.post('/api/index/getConduitCate')
}


//获取管道子分类详情
export function getConduitInfo(data) {
    return request.post('/api/index/getConduitInfo', data)
}

//获取案例信息
export function getCase() {
    return request.post('/api/index/getCase')
}


//获取新闻列表
export function getNewsList() {
    return request.post('/api/index/getNewsList')
}


//获取新闻详情
export function getNewsInfo(data) {
    return request.post('/api/index/getNewsInfo',data)
}


//获取服务详情
export function getServiceInfo(data) {
    return request.post('/api/index/getServiceInfo',data)
}


//获取营销网络地址信息
export function getMarketing() {
    return request.post('/api/index/getMarketing')
}


//获取关于我们的走进天亿公司列表
export function getCompany() {
    return request.post('/api/index/getCompany')
}


//获取关于我们的发展历程信息
export function getCourse() {
    return request.post('/api/index/getCourse')
}


//获取荣誉列表
export function getHonor(data) {
    return request.post('/api/index/getHonor',data)
}


//获取招聘列表
export function getRecruitList() {
    return request.post('/api/index/getRecruitList')
}


//获取招聘详情
export function getRecruitInfo(data) {
    return request.post('/api/index/getRecruitInfo',data)
}


//获取配置信息
export function getConfig() {
    return request.post('/api/index/getConfig')
}

